/* globals angular, _ */
(function () {
  'use strict';

  function TermsCtrl (
    $uibModal,
    $stateParams,
    Perfil,
    Pedido,
    TermsService,
    Cep
  ) {
    var ctrl = this;

    function _openModal() {
      $uibModal.open({
        animation: false,
        keyboard: false,
        backdrop: 'static',
        windowClass: 'modal-welcome',
        template: require('../../modal/modal-welcome/modal-welcome.html'),
        controller: 'ModalWelcomeCtrl as ctrl',
      });
    }

    function _triggerTrackingEvents(user) {
      var customerAddress = _.find(user.enderecos, function (endereco) {
        return endereco.ativo;
      });
      if (customerAddress == null) {
        customerAddress = _.first(user.enderecos);
      }
      Cep
        .buscarTipoVeiculoPorCepDadosColeta(customerAddress.cep)
        .then(function () {
        })
        .catch(function () {
        });
    }

    ctrl.onSubmit = function (form) {
      if (form.$invalid) { return; }
      ctrl.isBtnLoading = true;
      var user = $stateParams.user || Perfil.getCacheUserData();

      _triggerTrackingEvents(user);

      TermsService
        .accept({userId: user.id}, {aceiteTermoContrato: true})
        .$promise
        .then(function () {
          _openModal();
          Pedido.redirecionar();
        })
        .catch(function (error) {
          console.log(error.statusText);
        });
    };
  }

  angular
    .module('mandaeApp')
    .controller('TermsCtrl', TermsCtrl);
}());
